module.exports = __webpack_public_path__ + "static/media/contract.b2fc51a9.png";